import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import GSTHSN from './Gsthsn'

const CreateGstHsn = () => {
    return (
        <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
            <Helmet>
				<title>GST-HSN Code - Create</title>
			</Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column" style={{ flexGrow: '1' }}>
                <GSTHSN />
            </div>
        </div>
    );
};

export default CreateGstHsn;
